import React from 'react'
import { Grid } from "@mui/material"

import { AnalyzerEvolutionModal, AnalyzerPricesChart, AnalyzersTable } from "Pages/AnalyzersV2/@components"
import { isAnalyzerLoading, responseData } from "Pages/AnalyzersV2/@signals"
import useAnalyzerData from "Pages/AnalyzersV2/@hooks/useData"
import { NoDataFound, AppResultsSkeleton } from "@components"


export default function LorContent() {
	const {
		tableData,
		tableColumns,
		dataEmpty,
		evolutionData,
		chartContent,
		noResults
	} = useAnalyzerData(responseData.value)

	if (noResults) {
		return <NoDataFound/>
	}

	if (dataEmpty && !isAnalyzerLoading.value) return null

	return <Grid container spacing={2}>
		<Grid item xs={12}>
			{isAnalyzerLoading.value && <AppResultsSkeleton rows={10} columns={8}/>}
			{!isAnalyzerLoading.value &&
				<AnalyzersTable
					tableData={tableData}
					columns={tableColumns}
					evolutionData={evolutionData}
				/>}
		</Grid>
		<Grid item xs={12}>
			<AnalyzerPricesChart {...chartContent}/>
		</Grid>
		<Grid item xs={12}>
			<AnalyzerEvolutionModal/>
		</Grid>
	</Grid>

}